exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-list-item-group .v-list-item--active{color:inherit}", ""]);

// exports
